import React from 'react';
import { motion } from 'framer-motion';
import { Star, Users, Zap } from 'lucide-react';

const Hero: React.FC = () => {
  return (
    <section 
      className="pt-24 pb-16 px-4 sm:px-6 lg:px-8 relative"
      style={{
        backgroundImage: 'url(https://images.unsplash.com/photo-1607968565043-36af90dde238?q=80&w=3269&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      }}
    >
      {/* Overlay for better text readability */}
      <div className="absolute inset-0 bg-black/60"></div>
      
      <div className="max-w-7xl mx-auto relative z-10">
        <div className="text-center">
          {/* Main Headline */}
          <motion.h1 
            className="text-4xl md:text-6xl lg:text-7xl font-bold mb-6"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <span className="block text-white">STREAMING</span>
            <span className="block gradient-text">EQUIPMENT</span>
            <span className="block text-white">DONE RIGHT</span>
          </motion.h1>

          {/* Subtitle */}
          <motion.p 
            className="text-xl md:text-2xl text-gray-300 mb-8 max-w-3xl mx-auto"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            Professionelle Streaming-Setups für Creator, die Qualität schätzen. 
            <br className="hidden md:block" />
            Kuratiert, getestet, geliefert.
          </motion.p>

          {/* CTA Buttons */}
          <motion.div 
            className="flex justify-center mb-12"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
          >
            <a href="#bundles" className="btn-primary text-lg px-8 py-4 glow-hover">
              Equipment entdecken
            </a>
          </motion.div>

          {/* Stats */}
          <motion.div 
            className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.6 }}
          >
            <div className="text-center">
              <div className="flex items-center justify-center mb-2">
                <Users className="text-primary-500 mr-2" size={24} />
                <span className="text-3xl font-bold text-white">600+</span>
              </div>
              <p className="text-gray-400">Zufriedene Creator</p>
            </div>
            <div className="text-center">
              <div className="flex items-center justify-center mb-2">
                <Zap className="text-secondary-500 mr-2" size={24} />
                <span className="text-3xl font-bold text-white">15+</span>
              </div>
              <p className="text-gray-400">Manager</p>
            </div>
            <div className="text-center">
              <div className="flex items-center justify-center mb-2">
                <Star className="text-accent-500 mr-2" size={24} />
                <span className="text-3xl font-bold text-white">300+</span>
              </div>
              <p className="text-gray-400">Jahre Social Media Experience</p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
